// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const RaiseQuery = lazy(() => import('pages/query/raiseQuery'));

const RaiseQueryRoute = (
  <Route path={routeName.raiseQuery}>
    <Route
      index
      element={
        <PrivateRoute name={[PrivateRouteConst.VIEW_SIMULATION]}>
          <Suspense fallback={<Loading />}>
            <RaiseQuery />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RaiseQueryRoute;
